// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceCard-cls1_F11","cls2":"ReferenceCard-cls2_5uK ReferenceCard-cls1_F11"};